import { render, staticRenderFns } from "./ProductStatusBadge.vue?vue&type=template&id=3057fd33"
import script from "./ProductStatusBadge.vue?vue&type=script&lang=js"
export * from "./ProductStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports